import {BaseContainerModel} from "../../base-container.model";
import { bl_wf_md_resolution_RowClass, bl_wf_md_resolution_RowInterface } from "../../../dbschema";

export class WfMdResolutionContainerModel extends BaseContainerModel{
  bl_wf_md_resolution: bl_wf_md_resolution_RowInterface = new bl_wf_md_resolution_RowClass();
}
